module.exports = __webpack_public_path__ + "static/img/float-notice.3f313c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/float-notice.png
// module id = SB0+
// module chunks = 3